import { Image, ImageProps } from "@mantine/core";
import { Link } from "react-router-dom";
import { useScrollIntoView } from "@mantine/hooks";
import { client_selected } from "../../client";

interface IProps extends ImageProps {
  noText?: boolean;
}

const Logo: React.FC<IProps> = ({ noText, ...props }) => {
  const { scrollIntoView } = useScrollIntoView({ duration: 0 });
  const redirectClient = client_selected.redirect;

  const logo = client_selected.image.logo;
  const icon = client_selected.image.icon;

  return (
    <Link
      onClick={() => {
        scrollIntoView({ alignment: "start" });
      }}
      to={redirectClient}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Image
        {...props}
        src={noText ? logo : icon}
        alt="Logo"
        fit="contain"
        styles={{
          root: {
            cursor: "pointer",
            transition: "0.3s",
            ":hover": {
              opacity: "0.9",
              transition: "0.3s",
            },
          },
        }}
      />
    </Link>
  );
};

export default Logo;
